import { getGADataLayerData } from 'analytics'

type CreationWindow = typeof window & {
    dataLayer?: unknown[]
    didomiOnReady?: Array<() => void>
}

/**
 * Ported from legacy shared/util/analytics.ts:15-36, fired by manager.tsx on
 * every step change. Next's own useGA4 only fires on hard page load — it
 * carries a TODO saying exactly that — so client-side step navigation would
 * otherwise emit no page views at all.
 *
 * The didomiOnReady queue is legacy's consent gate and is not optional: pushing
 * before consent resolves means the pageview is dropped.
 */
export const trackStepPageView = (pathname: string) => {
    if (typeof window === 'undefined') return

    const win = window as CreationWindow
    if (!pathname || !win.dataLayer) return

    win.didomiOnReady = win.didomiOnReady || []
    win.didomiOnReady.push(() => {
        win.dataLayer?.push({
            event: 'VirtualPageview',
            virtualPageURL: pathname,
            virtualPageName: pathname,
            ...getGADataLayerData(),
        })
    })
}
